






































































































































import { Vue, Prop, Component } from "vue-property-decorator"
import { WebinarInfo } from "@/models/WebinarInfo"
import VideoPlayer from "../shared/VideoPlayer.vue"
import InfoTab from "../shared/InfoTab.vue"
import FullVideoCompoment from "../shared/FullVideoComponent.vue"
import IframeVideoPlayer from "../shared/IframeVideoPlayer.vue"
import { AwEventStore } from "@/models/AwEventStore"
import { AwEventType } from "@/models/AwEventType"
import { AnalyticsClient } from "@/services/AnalyticsService"
import { container } from "tsyringe"
var SocialSharing = require("vue-social-sharing")
Vue.use(SocialSharing)
import "@/assets/grid.scss"
@Component({
  components: {
    VideoPlayer,
    InfoTab,
    FullVideoCompoment,
    IframeVideoPlayer
  }
})
export default class GridLayout extends Vue {
  @Prop() public webinarInfo!: WebinarInfo

  socialShareUrl = ""
  mounted() {
    this.socialShareUrl = this.$root.$data.socialShareUrl
    var key = this.$root.$data.identifierKey
    const self = this
    this.$root.$on("social_shares_open", function (network: any, url: string) {
      var temp = url.split("/")
      var momentid = temp[temp.length - 1]
      var event: AwEventStore = {
        eventType: AwEventType.MomentShared,
        momentId: parseInt(momentid)
      }
      const _analytics = container.resolve(AnalyticsClient)
      _analytics.register(event, key)
    })
  }
}
